import { useMutation } from '@tanstack/react-query'
import { createLinkToken, createMeshLinkToken } from '@/app/lib/api-client'

export const useLegacyCreateLinkToken = () => {
  return useMutation({ mutationFn: createLinkToken })
}

export const useCreateLinkToken = () => {
  return useMutation({ mutationFn: createMeshLinkToken })
}
